var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"headline":"Fejl","visible":_vm.visible},on:{"close":function($event){return _vm.hide()}}},[_c('p',[_vm._v("Der skete desværre en fejl, mens du var i gang med din tilmelding. Din kurv er tom, og du må starte forfra.")])])}
var staticRenderFns = []

export { render, staticRenderFns }